export const getActiveTabDisplayName = (tabs, activeTab) => {
  const tab = tabs.find(tab => tab.value === activeTab);
  return tab ? tab.displayName : '';
};
